import React from "react"
import Img from "gatsby-image"
import { Link } from "gatsby"
import styled from "styled-components"
import { Row, Button, Col } from "react-bootstrap"
import { truncate } from "../../utils/truncate"

const StyledArticleCard = styled(Link)`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  /* border-top: 15px solid ${props => props.theme.primary}; */
  border-bottom: 15px solid ${props => props.theme.primary};
  margin-bottom: 60px;
  transition: all 0.2s ease-in-out;
  color: ${({ theme }) => theme.primary};
  
  &:hover {
    color: ${({ theme }) => theme.primary};
    text-decoration: none;
    transform: translateY(-15px);
  }
`

const StyledArticleImageWrapper = styled.div`
  position: relative;
  overflow: hidden;

  &:before,
  &:after {
    content: "";
    display: block;
    width: 125%;
    height: 30px;
    background: ${({ theme }) => theme.primary};
    z-index: 1;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  &:before {
    top: -15px;
    border-bottom-right-radius: 100%;
    border-bottom-left-radius: 100%;
    border-bottom: 7px solid ${({ theme }) => theme.primary};
  }
  &:after {
    bottom: -5px;
    border-top-right-radius: 100%;
    border-top-left-radius: 100%;
    border-top: 7px solid ${({ theme }) => theme.primary};
  }
`

const StyledArticleCardHeader = styled.div`
  background: ${({ theme }) => theme.primary};
  color: #fff;

  p {
    white-space: nowrap;
    width: 100%; /* IE6 needs any width */
    overflow: hidden; /* "overflow" value must be different from  visible"*/
    text-overflow: ellipsis; /* IE, Safari (WebKit), Opera >= 11, FF > 6 */
  }
`

const StyledArticleCardFooter = styled.div`
  margin: 15px 0;
`
const StyledArticleCardFeatured = styled.div`
  background: ${({ theme }) => theme.secondary};
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.8);
  height: 70px;
  left: -50px;
  position: absolute;
  top: -50px;
  width: 100px;
  z-index: 1;
  transform: rotate(-45deg);
`

export const ArticleCard = ({ article }) => {
  // console.log(article)

  return (
    <StyledArticleCard to={article.permalink}>
      <StyledArticleImageWrapper>
        {article.image && (
          <Img
            fixed={article.image.fixed}
            className="w-100"
            alt={article.image.title}
          />
        )}

        {article.isFeatured && <StyledArticleCardFeatured />}
      </StyledArticleImageWrapper>

      <StyledArticleCardHeader>
        <Col>
          <Row>
            <Col>
              <p>{article.title}</p>
            </Col>
          </Row>
        </Col>
      </StyledArticleCardHeader>

      <StyledArticleCardFooter>
        <Col>
          <Row>
            <Col>
              <p>
                {article.snippet &&
                  truncate(article.snippet.snippet, 100, true)}
              </p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="text-center">
              <Button variant="secondary">Read More</Button>
            </Col>
          </Row>
        </Col>
      </StyledArticleCardFooter>
    </StyledArticleCard>
  )
}
